import { defineMessages } from 'react-intl';

export default defineMessages({
    policyDetailsTitle: {
        id: 'policychange.wizard.step.Policy Details',
        defaultMessage: 'Policy Details',
    },
    fieldLabel: {
        id: 'twia.policychange.ho.views.policy-info.Primary Named Insured',
        defaultMessage: 'Primary Named Insured',
    },
    fieldLabelCompany: {
        id: 'twia.policychange.ho.views.policy-info.Name',
        defaultMessage: 'Name',
    },
    saveModalTitle: {
        id: 'twia.policychange.ho.views.policy-info.Please save or cancel',
        defaultMessage: 'Please save or cancel',
    },
    saveModalText: {
        id: 'twia.policychange.ho.views.policy-info.Please save or cancel changes before continuing',
        defaultMessage: 'Please save or cancel changes before continuing',
    },
    renewalScheduledMessage: {
        id: 'twia.policychange.cp.views.policy-info.renewal ScheduledMessage',
        defaultMessage: 'This policy has a renewal scheduled to take effect in the future. To apply this change to the future renewal term you must complete a separate policy change.',
    }
})